let logoutFn = null;
let accessTokenRef = null;

export const setAuthHelper = (fn) => {
  logoutFn = fn;
};

export const clearSession = () => {
  if (logoutFn) logoutFn();
};

export const setAccessTokenRef = (token) => {
  accessTokenRef = token;
};

export const getAccessTokenRef = () => accessTokenRef;
